export function cleanEmail(email = '') {
    return email.split('@')[0].replace(/[._-]/g, ' ')
}

export default cleanEmail
